import { render, staticRenderFns } from "./Oto.vue?vue&type=template&id=f7cb23ec&scoped=true&"
import script from "./Oto.vue?vue&type=script&lang=js&"
export * from "./Oto.vue?vue&type=script&lang=js&"
import style0 from "./Oto.vue?vue&type=style&index=0&id=f7cb23ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7cb23ec",
  null
  
)

export default component.exports